import { takeLatest, put, select } from "redux-saga/effects";
import {
  SET_RM_BUDDIES_SEARCH_QUERY,
  setVisibleRmBuddiesList,
  SET_RM_BUDDIES_FILTER_BUDDY_BLOCK,
  SET_RM_BUDDIES
} from "../actions";

const FlexSearch = require("flexsearch");

const index = new FlexSearch({
  profile: "match",
  doc: {
    id: "_id",
    field: ["name", "phone_num"]
  }
});

export function* newIndexTask(action) {
  if (index.info().items !== 0) {
    index.clear();
  }
  const docs = yield select(({ rmBuddies }) => rmBuddies.rmBuddiesList);
  index.add(docs);
}

export function* watchSetRmBuddies() {
  yield takeLatest(SET_RM_BUDDIES, newIndexTask);
}
export function* searchAndFilterTask(action) {
  let list;
  if (action.payload) {
    if (index.info().items === 0) {
      const docs = yield select(({ rmBuddies }) => rmBuddies.rmBuddiesList);
      index.add(docs);
    }
    list = index.search({
      query: action.payload,
      suggest: false
    });
  } else {
    list = yield select(({ rmBuddies }) => rmBuddies.rmBuddiesList);
  }
  const blockId = yield select(
    ({ rmBuddies }) => rmBuddies.rmBuddiesFilter.buddyBlockId
  );
  let searchResults;
  if (blockId) {
    searchResults = list.filter(e => e.buddy_block_ids.indexOf(blockId) !== -1);
  } else {
    searchResults = list;
  }
  yield put(setVisibleRmBuddiesList(searchResults));
}

export function* watchRmBuddiesSearchQuery() {
  yield takeLatest(SET_RM_BUDDIES_SEARCH_QUERY, searchAndFilterTask);
}

export function* rmBuddiesListBlockFilterTask(action) {
  const query = yield select(
    ({ rmBuddies }) => rmBuddies.rmBuddiesFilter.searchQuery
  );
  let list;
  if (query) {
    list = index.search({
      query,
      suggest: false
    });
  } else {
    list = yield select(({ rmBuddies }) => rmBuddies.rmBuddiesList);
  }
  if (!action.payload) {
    yield put(setVisibleRmBuddiesList(list));
    return;
  }
  const searchResults = list.filter(
    e => e.buddy_block_ids.indexOf(action.payload) !== -1
  );
  yield put(setVisibleRmBuddiesList(searchResults));
}

export function* watchRmBuddiesBuddyBlockId() {
  yield takeLatest(
    SET_RM_BUDDIES_FILTER_BUDDY_BLOCK,
    rmBuddiesListBlockFilterTask
  );
}
